import ServerStack from "public/openStack/deployment/fa6-solid_server.svg";
import CloudVector from "public/openStack/deployment/heroicons_cloud-16-solid.svg";
import RecoveryVector from "public/openStack/deployment/wpf_refresh-shield.svg";

export const DEPLOYMENT_CONSTANTS = [
  {
    image: ServerStack,
    title: "Bare Metal Hosting",
    text: "In OneMind Data Centers",
  },
  {
    image: CloudVector,
    title: "Hybrid Cloud",
    text: "With public cloud bursting",
  },
  {
    image: RecoveryVector,
    title: "Disaster Recovery",
    text: "Multi-site HA available",
  },
];
